<template>
  <div>
    <div class="m-b-40">
      <div class="dg-card">
        <ManualShipmentRow
          v-for="(item, index) in value" :key="`ms-row-${index}`"
          :deletable="value.length > 1"
          :indexInData="index"
          :shippingAgents="shippingAgentOptions"
          :shippingProducts="shippingProducts"
          @deleteRow="deleteRow(index)"
          v-model="value[index]" />
        <div class="clear-float">
          <Btn @click.native="addRow"
               class="brand float-left m-r-20"
               :icon="{name: 'plus', size: '20'}"
               :btnText="$t('add_row')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import mixin from "@/mixins/mixins";
import Btn from "@/components/elements/buttons/button";
import Toggle from "@/components/elements/inputs/toggle";
import DimensionsSelect from "@/components/elements/inputs/dimensionsSelect";
import WeightSelect from "@/components/elements/inputs/weightSelect";
import NestedSelect from "@/components/elements/inputs/nestedSelect";
import ManualShipmentRow from "@/components/pickup/manualShipmentRow";
import {mapGetters} from "vuex";

export default {
  name: 'ManualShipmentsBlock',
  mixins: [mixin],
  components: {
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    NestedSelect,
    ManualShipmentRow
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [
          {
            shippingAgentId: '',
            shippingProductId: '',
            trace_no: '',
            goodsType: 1,
            weight: {
              value: '',
              unit: 'kg',
            },
            dimensions: {
              width: {
                value: '',
                disabled: false,
              },
              height: {
                value: '',
                disabled: false,
              },
              length: {
                value: '',
                disabled: false,
              },
              dimensionsType: '',
            },
          }
        ]
      }
    }
  },
  data() {
    return {
      shippingAgentIds: [],
      shippingAgentOptions: [],
      shippingProducts: []
    }
  },
  computed: {
    ...mapGetters([
      'get_pickup_allowed_freight_products'
    ]),
  },
  mounted() {
    this.getShippingAgentsAndProducts();
  },
  methods: {
    getShippingAgentsAndProducts() {
      this.$store.dispatch('GET_PICKUP_ALLOWED_FREIGHT_PRODUCTS').then((res) => {
        this.shippingAgentIds = [];
        this.shippingAgentOptions = [];
        this.shippingProducts = [];

        let groupedProducts = [];
        res.forEach((item) => {
          const shippingAgentKey = `agent-${item.shipping_agent_id.toString()}`;

          if (!groupedProducts[shippingAgentKey]) {
            groupedProducts[shippingAgentKey] = [];
          }

          groupedProducts[shippingAgentKey].push({
            text: item.product_name,
            value: item.shipping_product_id,
          });

          if (!this.shippingAgentIds.includes(item.shipping_agent_id)) {
            this.shippingAgentOptions.push({
              text: item.shipping_agent,
              value: item.shipping_agent_id
            });
            this.shippingAgentIds.push(item.shipping_agent_id);
          }
        });
        this.shippingProducts = groupedProducts;
      });
    },
    deleteRow(index) {
      this.$emit('input', this.value.filter((item, idx) => idx !== index));
    },
    addRow() {
      this.$emit('input', [
        ...this.value,
        {
          shippingAgentId: '',
          shippingProductId: '',
          trace_no: '',
          goodsType: 1,
          weight: {
            value: '',
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: '',
              disabled: false,
            },
            height: {
              value: '',
              disabled: false,
            },
            length: {
              value: '',
              disabled: false,
            },
            dimensionsType: '',
          },
        }
      ]);
    },
  },
}
</script>
